<script lang="ts">
    export let type: 'button' | 'submit' = 'submit';
    export let disabled: boolean = false;
    export let loading: boolean = false;
    export let loadingLabel: string = 'Loading…';
    export let fullWidth: boolean = true;
</script>

<button
    {type}
    class="auth-button"
    class:auth-button--inline={!fullWidth}
    disabled={disabled || loading}
    on:click
>
    {#if loading}
        <span class="auth-btn-spinner" aria-hidden="true"></span>
        <span>{loadingLabel}</span>
    {:else}
        <slot />
    {/if}
</button>
